import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import TireLineTile from '../TireLineTile'

const TireLinesList = ({
  handleStoreSearch,
  hasActiveVehicle,
  hasStore,
  cappedProducts,
  brandName,
  displayingAllItems
}) =>
  <Wrapper addMargin={ !displayingAllItems }>
    {
      cappedProducts.map((row, rowIndex) =>
        <Row
          id={ `tire_row_${rowIndex + 1}` }
          key={ rowIndex }>
          {
            row.map((product, productIndex) =>
              <TireLineTile
                key={ product.productLink }
                { ...product }
                index={ productIndex + (rowIndex * row.length) }
                brandName={ brandName }
                handleStoreSearch={ handleStoreSearch }
                hasActiveVehicle={ hasActiveVehicle }
                hasStore={ hasStore } />
            )
          }
        </Row>
      )
    }
  </Wrapper>

export default TireLinesList

TireLinesList.propTypes = {
  brandName: PropTypes.string,
  cappedProducts: PropTypes.arrayOf(PropTypes.array),
  displayingAllItems: PropTypes.bool,
  handleStoreSearch: PropTypes.func,
  hasActiveVehicle: PropTypes.bool,
  hasStore: PropTypes.bool
}

const Wrapper = styled.div`
  ${Mixin.clearFix()}
  margin-bottom: ${props => props.addMargin ? '500px' : '5px'};
`

const Row = styled.div`
  &:not(:first-child) {
    margin-top: 61px;
  }
`
